import styled from '@emotion/styled';

export const LoadMore = styled.button`
  outline: none;
  border: none;
  background: none;
  margin-top: ${({ theme }) => theme.spacings[6]};
  cursor: pointer;
`;
